import React, { useContext, useEffect, useState } from 'react';
import "./Fundallotment.css";
import Application from '../../../StateContext/Application';

const FundAllotment = () => {
  let operation = useContext(Application);
  const { FundAllomentOperation } = operation;

  const [FetchedData, setFetchData] = useState([]);
  const [editIndex, setEditIndex] = useState(null);

  const [data, setData] = useState({
    fundAllomentType: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const HandleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (data.fundAllomentType == "") {
        return alert("Not insert Type of Alloment !!");
      }
      console.log("Data", data);
      let res = await FundAllomentOperation("CreateFundAllotment", data);
      console.log("baclkend message : ", res);
      alert(res);
      FetchDataintially();
    }
    catch (err) {
      console.log(err);
    }
  }



  const FetchDataintially = async () => {
    try {
      let res = await FundAllomentOperation("", "null");
      setFetchData(res);
      console.log("Reocreder dta ; ", res);
    }
    catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    FetchDataintially();
  }, []);

  const EditFundAllotment = (id) => {
    let editinfo = FetchedData.filter((item) => item.fundID === id);
    let info = editinfo[0];
    console.log(info);
    setEditIndex(id);
    setData({
      fundAllomentType: info.FundAllotmentType
    })
  };


  const SubmitEdittedData = async (e) => {
    e.preventDefault();
    try {
      let obj = {
        fundAllomentType: data.fundAllomentType,
        fundId: editIndex
      }
      let res = await FundAllomentOperation("EditFundAllotment", obj);
      alert(res);

      setEditIndex("");
      setData({
        fundAllomentType: ""
      });
      window.location.reload();
    }
    catch (err) {
      console.log(err);
    }
  }

  const DeleteFundAllotment = async (id) => {
    let final = window.confirm("Are you sure ??");

    if (final) {
      try {
        let res = await FundAllomentOperation("DeleteFundAllotment", id);
        alert(res);
        FetchDataintially();
      }
      catch (err) {
        console.log(err);
      }
    }
    else{
      alert("Cancel Deletion !!");
    }
  }




  return (
    <>


      <div className="col-12">
        <h3 className='text-center fw-bold bg-light'>Fund Alloment</h3>
        <div className="col-12 m-auto my-5 fundAllomentContainer">
          <div className="m-auto budgetElement">
            <div className="col-10 m-auto">
              <form action="" >

                <div className="col-12 elements">
                  <div className="row">
                    <div className="col-4 my-auto ">
                      <label className='my-auto' >Fund Allotment Type </label>
                    </div>
                    <div className="col-8">
                      <input type="text" placeholder='Enter Fund Allotment Type' value={data.fundAllomentType} name='fundAllomentType' onChange={(handleChange)} />
                    </div>
                  </div>
                </div>

                <div className="col-12 text-center my-4 mt-5">
                  {
                    !editIndex &&
                    <button className='btn btn-success px-4' onClick={HandleSubmit}>Submit</button>
                  }
                  {
                    editIndex &&
                    <button className='btn btn-success px-4' onClick={SubmitEdittedData}>Update</button>
                  }
                  <button className='btn btn-danger px-4 mx-3' onClick={(e) => { e.preventDefault(); setEditIndex(""); setData({ fundAllomentType: "" }) }}>Cancel</button>
                </div>
              </form>

            </div>

          </div>


          <div className="col-10 m-auto">
            <div className="tableContainer my-5">
              <table>
                <thead>
                  <tr>
                    <th style={{ width: "15%" }}>Sr.No</th>
                    <th style={{ width: "15%" }}>Fund Alloted ID </th>
                    <th style={{ width: "50%" }}>Fund Allotment Type</th>
                    <th style={{ width: "10%" }}></th>
                    <th style={{ width: "10%" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    FetchedData.length > 0 &&
                    FetchedData.map((val, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{val.fundID}</td>
                          <td>{val.FundAllotmentType}</td>
                          <td><button className='btn btn-success px-4' onClick={() => EditFundAllotment(val.fundID)}>Edit</button></td>
                          <td><button className='btn btn-danger px-4' onClick={() => DeleteFundAllotment(val.fundID)}>Delete</button></td>
                        </tr>

                      )
                    })
                  }
                </tbody>
              </table>

            </div>
          </div>


        </div >
      </div >





    </>
  )
}

export default FundAllotment;